import { PinComponentType } from '@lessonup/pins-shared';
import {
  IconComponentAudio,
  IconComponentHotspot,
  IconComponentImage,
  IconComponentLine,
  IconComponentShape,
  IconComponentSpinner,
  IconComponentText,
  IconComponentTimer,
  IconComponentVideo,
  IconJigsaw,
} from '@lessonup/ui-components';
import React from 'react';

export interface PinComponentTypeIconProps {
  componentType: PinComponentType;
  className?: string;
}

export function PinComponentTypeIcon({ componentType, className }: PinComponentTypeIconProps) {
  switch (componentType) {
    case 'TEXT':
      return <IconComponentText className={className} />;
    case 'IMAGE':
      return <IconComponentImage className={className} />;
    case 'SHAPE':
    case 'UNEDITABLE_SHAPE':
      return <IconComponentShape className={className} />;
    case 'AUDIO':
      return <IconComponentAudio className={className} />;
    case 'VIDEO':
      return <IconComponentVideo className={className} />;
    case 'HOTSPOT':
      return <IconComponentHotspot className={className} />;
    case 'LINE':
      return <IconComponentLine className={className} />;
    case 'SPINNER':
      return <IconComponentSpinner className={className} />;
    case 'TIMER':
      return <IconComponentTimer className={className} />;
    default:
      return <IconJigsaw className={className} />;
  }
}
